"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const constants_1 = require("@/constants");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Styles = {
    input: (props) => core_1.css `
    border-width: 1px;
    border-style: solid;
    border-color: ${styles_scss_1.default.grey};
    ${props.success ? `border-color: ${styles_scss_1.default.success};` : ''}
    ${props.error ? `border-color: ${styles_scss_1.default.errorColor};` : ''}

    &:focus {
      border-color: ${props.error ? styles_scss_1.default.errorColor : styles_scss_1.default.primary};
      outline: none;
    }

    &:focus + label {
      color: ${props.error ? styles_scss_1.default.errorColor : styles_scss_1.default.primary};
    }

    ${props.error && `
      & + label {
        color: ${styles_scss_1.default.errorColor};
      }
    `}
  `,
    label: (props) => core_1.css `
      color: ${props.isFocus ? styles_scss_1.default.primary : styles_scss_1.default.darkGrey};
      ${props.error ? `color: ${styles_scss_1.default.errorColor}; ` : ''}
  `,
    searchInput: () => core_1.css `
    input[type="search"]::-webkit-search-cancel-button {
      -webkit-appearance: none;
      height: 18px;
      width: 18px;
      cursor: pointer;
      border-radius: 50em;
      background: url(${constants_1.Images.clear}) no-repeat 50% 50%;
      background-size: contain;
      opacity: 0;
      pointer-events: none;
    }
  
    input[type="search"]:focus::-webkit-search-cancel-button {
      opacity: 1;
      pointer-events: all;
    }
  
    input[type="search"].dark::-webkit-search-cancel-button {
      filter: invert(1);
    }
  `,
    accessory: (props) => core_1.css `
    ${props.accessoryPosition === 'right' ? 'right: 10px;' : 'left: 12px;'}
  `
};
exports.default = Styles;
